export default "__VITE_PUBLIC_ASSET__8499c804__"